import styled from "vue-styled-components";

export const Content = styled.div`
    display: block;
    width: 100%;
    margin-bottom: 1rem;

    span {
        margin-bottom: 1rem;

        strong {
            color: tomato;
        }
    }
`;
